import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogRef as MatDialogRef } from '@angular/material/dialog';

type ConfirmModalTone = 'default' | 'danger' | 'highlight';

@Component({
    selector: 'app-confirm-modal',
    templateUrl: './confirm-modal.component.html',
    styleUrls: ['./confirm-modal.component.scss'],
    standalone: false
})
export class ConfirmModalComponent implements OnInit {
  public title: string;
  public message: string;
  public cancelText: string = 'Cancel';
  public confirmText: string = 'Confirm';
  public eyebrow: string = '';
  public icon: string = 'help_outline';
  public tone: ConfirmModalTone = 'default';

  constructor(
    public dialog: MatDialogRef<ConfirmModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    this.title = this.data.title;
    this.message = this.data.message;
    this.cancelText = this.data.cancelText;
    this.confirmText = this.data.confirmText;
    this.eyebrow = this.data.eyebrow ?? '';
    this.icon = this.data.icon ?? 'help_outline';
    this.tone = this.data.tone ?? 'default';
  }

  close() {
    this.dialog.close(false);
  }

  confirm() {
    this.dialog.close(true);
  }
}
